"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var Breadcrumbs = function (_a) {
    var children = _a.children, _b = _a.separator, separator = _b === void 0 ? "/" : _b, _c = _a.separatorColor, separatorColor = _c === void 0 ? "primaryLight" : _c, _d = _a.gap, gap = _d === void 0 ? theme_1.theme.space[1] + "px" : _d;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { as: "ul", sx: {
            padding: 0,
            alignItems: "baseline"
        } }, react_1.Children.map(children, function (child, key) {
        if (!react_1.isValidElement(child)) {
            return null;
        }
        return react_1.cloneElement(child, {
            gap: gap,
            separator: separator,
            separatorColor: separatorColor,
            key: key,
        });
    })));
};
exports.Breadcrumbs = Breadcrumbs;
